// React
import React, { useRef } from 'react'
import PropTypes from 'prop-types'

// Components
import BCartPicker from 'ui/blocks/Picker/types/cart'
import { FreePicker } from './Picker'
import Icon from 'ui/components/Icon'
import Span from 'ui/elements/Span'

// Hooks
import { usePicker } from 'ui/components/Picker/hooks'
import useWindowSize from 'shared/utils/useWindowSize'
import { useTranslation } from 'shared/utils/useTranslation'

export const FreeDesktop = (props) => {
  const portalRef = useRef(null)

  const picker = usePicker()

  const { width } = useWindowSize()

  const { t } = useTranslation('user')

  // 866px is the breakpoint when the modal is starting to shrink
  const numberOfMonths = (width > 866 && props.inline) ? 2 : 1

  return (
    <FreePicker
      {...props}
      numberOfMonths={numberOfMonths}
      portalRef={portalRef}
      usePortal={{
        date: props.inline,
        time: false
      }}
    >
      <BCartPicker.Portal ref={portalRef}>
        <BCartPicker.PeriodReset onClick={picker.reset} data-tid="Clear dates">
          <Icon icon="times" />
          <Span>{t('user.store.reset_period')}</Span>
        </BCartPicker.PeriodReset>
      </BCartPicker.Portal>
    </FreePicker>
  )
}

FreeDesktop.propTypes = {
  inline: PropTypes.bool
}
